import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=0aec008b"
import script from "./Reset.vue?vue&type=script&lang=js"
export * from "./Reset.vue?vue&type=script&lang=js"
import style0 from "./Reset.vue?vue&type=style&index=0&id=0aec008b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports